import React, { useEffect, useRef } from "react";
import "./EditEventTypeInput.scss";
import "@aurodesignsystem/auro-button";
import { createEventType } from "../../services/otsEventService";
import "@aurodesignsystem/auro-dropdown";
import "@aurodesignsystem/auro-menu"
import { EventTypeInput} from "../../Models/EventType";
import CancelModal from "../Modal/CancelModal";
import {useAuthentication} from "meportal/AuthenticationProvider";
import { GroupPermissions, createEventTypePermissions, EventTypeAssignmentsRequest, Group, Permission }from "meportal/AuthorizationProvider";
import { useEventType } from "../../providers/EventTypeProvider";
import LockedSwitch from "./LockedSwitch"
import { useHistory } from "react-router-dom";

const Overlay = () => {
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(245, 246, 248, 0.5)',
            zIndex: 2,
        }}></div>
    );
}


interface CreateEventTypeProps {
    refreshDashboard: any; 
  }

export default function CreateEventType(props: CreateEventTypeProps) {
    const { userData, getLatestAccessToken } = useAuthentication();
    const { eventTypes } = useEventType();
    const [isSubmitDisabled, setIsSubmitDisabled] = React.useState(true);
    const [groupAssignments, setGroupAssignments] = React.useState<Group[]>();
    const [eventTypeName, setEventTypeName] = React.useState("");
    const [isEventTypeNameValid, setIsEventTypeNameValid] = React.useState(false);
    const [reason, setReason] = React.useState("");
    const [isReasonValid, setIsReasonValid] = React.useState(false);
    const [category, setCategory] = React.useState(null);
    const [isCategorySelected, setIsCategorySelected] = React.useState(false);
    const [isLocked, setIsLocked] = React.useState(false);
    const [status, setStatus] = React.useState("");
    const [clonedEventTypeSelected, setClonedEventTypeSelected] = React.useState("");
    const categoryRef = useRef(null);
    const cloneRef = useRef(null);
    const history = useHistory();

    useEffect(() => {
      const control = categoryRef.current;
      const handleSelectedOption = (elem) => {
        console.log("selected option: ", elem.target.value)
        setCategory(elem.target.value);
        setIsCategorySelected(true);
        validToSubmit(isEventTypeNameValid, isReasonValid, true);
      };
  
    if (control) {
        control.addEventListener('selectedOption', handleSelectedOption);
    }
  
      // Clean up function
      return () => {
        if (control)
        { control.removeEventListener('selectedOption', handleSelectedOption); }
      };
    }, []); // Empty dependency array means this effect runs once on mount and clean up on unmount
  
    useEffect(() => {
        const control = cloneRef.current;
        const handleCloneSelectedOption = (elem) => {
          setClonedEventTypeSelected(elem.target.value);
          setIsCategorySelected(true);
        };
    
      if (control) {
          control.addEventListener('selectedOption', handleCloneSelectedOption);
      }
    
        // Clean up function
        return () => {
          if (control)
          { control.removeEventListener('selectedOption', handleCloneSelectedOption); }
        };
      }, []); // Empty dependency array means this effect runs once on mount and clean up on unmount
    
    const validToSubmit = (nameValid: boolean, reasonValid: boolean, categoryValid: boolean) => {
        if (nameValid && reasonValid && categoryValid) {
            setIsSubmitDisabled(false);
        } else {
            setIsSubmitDisabled(true);
        }
    }
    const handleReasonValue = (event: any) => {
        // Strip HTML from the input value
        let sanitizedText = stripHtmlTags(event.target.value);
        sanitizedText = sanitizedText.replace(/['";]/g, '');
        event.target.value = sanitizedText;
        setReason(event.target.value);
        if (event.target.value.length > 0) {
            setIsReasonValid(true);
            validToSubmit(isEventTypeNameValid, true, isCategorySelected);
        } else {
            setIsReasonValid(false);
            validToSubmit(isEventTypeNameValid, false, isCategorySelected);
        }
    };

    const stripHtmlTags = (input: string) => {
        const doc = new DOMParser().parseFromString(input, 'text/html');
        return doc.body.textContent || "";
      };

    const handleNameValue = (event: any) => {
        // Strip HTML from the input value
        let sanitizedText = stripHtmlTags(event.target.value);
        sanitizedText = sanitizedText.replace(/['";]/g, '');
        event.target.value = sanitizedText;
        setEventTypeName(event.target.value);
        setIsEventTypeNameValid(event.target.isValid);
        if (event.target.value.length > 0) {
            setIsEventTypeNameValid(true);
            validToSubmit(true, isReasonValid, isCategorySelected);
        } else {
            setIsEventTypeNameValid(false);
            validToSubmit(false, isReasonValid, isCategorySelected);
        }
    };

    const handleGroupAssignments = (groups: Group[]) => {
        setGroupAssignments(groups);
    }

    const handleAddSubmit = () => {
        setStatus("loading");
        let input: EventTypeInput = {
            Airline: userData.profile.company,
            Name: eventTypeName.trim(),
            ReasonForEventType: reason.trim(),
            ReasonForActiveChanged: "",
            IsActive: true,
            Category: category ? category : "",
            CreatedBy: userData.profile.given_name + " " + userData.profile.family_name,
            CreatedDateTimeUTC: new Date().toISOString(),
            LastUpdatedBy: userData.profile.given_name + " " + userData.profile.family_name,
            LastUpdatedDateTimeUTC: new Date().toISOString(),
            IsSubmitDisabled: false,
            IsLocked: isLocked
        };
        getLatestAccessToken().then((token) => {
            userData.access_token = token;
            createEventType(userData, input)
                .then((statusCode) => {
                    if (statusCode.status) {
                        if(groupAssignments === undefined)
                        { 
                            setStatus("success");
                            setTimeout(() => {
                                props.refreshDashboard();
                                history.push('/event-types');
                            }, 5000);
                            return; 
                        }
                        let request = createEventTypePermissionsRequest(groupAssignments);
                        createEventTypePermissions(userData, request)
                            .then((statusCode) => {
                                console.log("statusCode create event type permissions: ", statusCode);
                                if (successcondition(statusCode)) {
                                    setStatus("success");
                                    setTimeout(() => {
                                        props.refreshDashboard();
                                        history.push('/event-types');
                                    }, 5000);
                                } else {
                                    setStatus("error");
                                    setTimeout(() => {
                                        setStatus("");
                                    }, 5000);
                                }
                            });
                    } else {
                        setStatus("error");
                        setTimeout(() => {
                            setStatus("");
                        }, 5000);
                    }
                })
                .catch(() => {
                    console.log("Failed Error createOTSEvent");
                    setStatus("error");

                    setTimeout(() => {
                        setStatus("");
                    }, 5000);
                });
        });
    };
    
    const successcondition=(statusCode:any)=>{
       return statusCode === 200 || statusCode.status;
    }

    const createEventTypePermissionsRequest = (groupAssignments: Group[]) => { 
        let groupsToAdd: Group[] = [];
        groupAssignments.forEach((group: Group) => {
            let groupToAdd: Group = {
                Name: group.Name,
                Permissions: group.Permissions.filter((perm: Permission) => perm.checked),
            };
            groupToAdd.Permissions.map((perm: Permission) => { perm.IsActive = true});
            groupsToAdd.push(groupToAdd);
        });
        let request: EventTypeAssignmentsRequest = {
            eventTypeId: userData.profile.company + ":" + eventTypeName.trim(),
            groups: groupsToAdd,
            lastUpdatedBy: userData.profile.given_name + " " + userData.profile.family_name,
        };
        console.log(request);
        return request;
    }
    const [showCancelModal, setShowCancelModal] = React.useState(false);

    const handleClose = () => {
        setShowCancelModal(true);
    };

    const handleKeepEditing = () => {
        setShowCancelModal(false);
    };

    const handleCancelEvent = () => {
        props.refreshDashboard();
        history.push('/event-types');
        setShowCancelModal(false);
    };

    const handleLockedChange = ( isOn: boolean) => {
        setIsLocked(isOn);
    }

    return (
        <React.Fragment>
            {status !== "" && <Overlay />}
            <div>
                <div className="input-form-container">
                    <div className="sectionHeaderLabel">Event type details </div>  
                    <div className="create-event-type-list">
                        <div className="input-item eventNameField">
                            <auro-input
                                required
                                bordered
                                value={eventTypeName}
                                onBlur={handleNameValue}
                                onInput={handleNameValue}>
                                <span className="label" slot="label">Event type name</span>
                            </auro-input>
                        </div>
                        <div className="input-item drpdwn-event-type-category">
                            <auro-select ref={categoryRef} value={category}  required placeholder="Legacy category"
                            setCustomValidityValueMissing="A category selection is required"
                            >
                            {category && <span slot="label">Legacy category</span>}
                            <auro-menu>
                                <auro-menuoption value="Unscheduled">Unscheduled</auro-menuoption>
                                <auro-menuoption value="Scheduled">Scheduled</auro-menuoption>
                                <auro-menuoption value="NotApplicable">Not applicable</auro-menuoption>
                            </auro-menu>
                            </auro-select>
                        </div>
                        <div className="input-item-full-width reason-container">
                            <auro-input
                            data-testid="reason-text"
                            className="reason-text"
                            required
                            validateOnInput
                            bordered
                            pattern="^[^\s].*"
                            maxlength="200"
                            setCustomValidity="Enter valid reason for creating event type"
                            placeholder="reason"
                            value={reason}
                            onBlur={handleReasonValue}
                            onInput={handleReasonValue}>
                            <span className="label" slot="label">Enter reason for creating event type</span>
                            </auro-input>
                        </div>
                        
                    </div>
                    <LockedSwitch toggleSwitch={handleLockedChange} />
                    <GroupPermissions 
                        applicationName="OutOfServiceRecovery"
                        eventId={clonedEventTypeSelected}
                        setGroups={handleGroupAssignments}
                        groups = {groupAssignments}
                        isModal = {false}
                        eventTypes = {eventTypes}
                    />
     
                    <footer className="create-event-type-footer">
                    <div className="buttons-section">
                        {status === "loading" && <auro-button loading variant="primary" fluid />}
                        {status === "success" && <button className="success-button"><h2 className="alert-text">Event created Successfully!</h2></button>}
                        {status === "error" && <button className="error-button"><h2 className="alert-text">Event creation failed. Try again!</h2></button>}
                        {status === "" &&
                            <div className="footer-buttons-container">
                                <div className="footer-button">
                                    <auro-button variant="secondary" fluid onClick={handleClose}>
                                        <span className="btnlabel-blue">Cancel</span>
                                    </auro-button>
                                </div>
                                <div className="footer-button">
                                    <auro-button variant="primary" fluid 
                                    class={isSubmitDisabled ? "disabled" : ""} 
                                    onClick={handleAddSubmit}>
                                    <span className="btnlabel-white">Create</span>
                                    </auro-button>
                                </div>
                            </div>
                        }
                    </div>
                    </footer>
                  
                </div>
            </div>
            <CancelModal isOpen={showCancelModal} 
            message="Are you sure you want to cancel the new event type?"
            title="Cancel new event type" 
            buttonText="Yes" 
            close={handleKeepEditing} 
            confirm={handleCancelEvent} />
        </React.Fragment>

    );
}
